import * as yup from 'yup';
import { isFieldVisible } from '../../helpers';
import { buildDefaults } from '../shared/campaignDefaults';
import {
  hasBaseErrors,
  hasCaptureErrors,
  hasInvalidScheduledDelay,
  hasMissingScheduledTime,
} from '../shared/primaryActionChecks';
import { commonSchemaShape, withMessageOrderTest } from '../shared/validationSchema';
import { CampaignTypeSpec } from '../policy';
import { policyIssue } from '../issues';
import { standardFields, withCampaignDateSchedule } from './shared';

export const awayMessageSpec: CampaignTypeSpec = {
  externalType: 'custom',
  fields: standardFields,
  defaults: config => buildDefaults(config, { scheduledType: 'immediate' }),

  issues: (values, config) => policyIssue(
    hasBaseErrors(values, config)
    || hasCaptureErrors(values)
    || hasInvalidScheduledDelay(values)
    || hasMissingScheduledTime(values),
    'away-message-primary-blocked',
  ),

  payload: ({ base, values, config }) => {
    const { dateScheduled, scheduledMessages } = withCampaignDateSchedule(base.scheduledMessages);
    return {
      ...base,
      groups: values.groupIds ?? [],
      keywords: isFieldVisible(config.keywords) ? values.keywordIds : undefined,
      scheduledMessages,
      ...(dateScheduled ? { dateScheduled } : {}),
    };
  },

  schema: config => withMessageOrderTest(
    yup.object(commonSchemaShape(config, { messages: true })),
  ),
};
